export const ru = {
    'error-get-revisions-description': 'Попробуйте снова',
    'error-get-revisions-title': 'Не удалось загрузить список версий',
    title: 'История изменений',
    'tooltip-compare': 'Добавить к сравнению',
    'tooltip-current': 'Текущая версия',
    'tooltip-del': 'Удалить из сравнения',
    'tooltip-old-editor': 'Версия в старом редакторе, недоступна для редактирования'
};
